<div class="container-fluid">
    <div class="row dark py-2">
        <div class="col-md-12 header-center">
            <h3>SERVICES</h3>
            <div>
                <p class="separator"> </p>
            </div>
        </div>
    </div>
    
    <div class="row dark custom-height">
    
        <div class="col-md-4 my-2">
            <div class="card border-info" style="width: 19rem;">
                <a href="https://www.flaticon.com/" title="Flaticon" class="text-center my-2">
                    <img src="../../assets/icons/computer.png" alt="Freelancing" class="img-rounded img-fluid"
                        width="50%" /></a>
                <div class="card-body">
                    <h5 class="card-title text-center">FREELANCING</h5>
                    <p class="card-text text-center">
                        Website development in Tech stack - Java, Spring Boot Microservices, React, Angular,.
                        Providing mentorship in understanding your work and code.
                        <b>₹999/2hr session</b>
                    </p>
                    <a href="mailto:rohit.rana0207@gmail.com" class="btn btn-hire btn-block">Contact</a>
                </div>
            </div>
        </div>
    
        <div class="col-md-4 my-2">
            <div class="card border-info" style="width: 19rem;">
                <a href="https://www.flaticon.com/" title="Flaticon" class="text-center my-2">
                    <img src="../../assets/icons/video-call.png" alt="Technical Interviews" class="img-rounded img-fluid"
                        width="50%" /></a>
                <div class="card-body">
                    <h5 class="card-title text-center">TECHNICAL INTERVIEWS</h5>
                    <p class="card-text text-center">
                        Short of interviewers?
                        I can help in Frontend and Backend interviews.
                        In mentioned Tech Stack.
                        <b>₹499/interview</b>
                    </p>
                    <a href="mailto:rohit.rana0207@gmail.com" class="btn btn-hire btn-block">Contact</a>
                </div>
            </div>
        </div>
        <div class="col-md-4 my-2">
            <div class="card border-info" style="width: 19rem;">
                <a href="https://www.flaticon.com/" title="Flaticon" class="text-center my-2">
                    <img src="../../assets/icons/technical-support.png" alt="Technical Dev Support" class="img-rounded img-fluid"
                        width="50%" /></a>
                <div class="card-body">
                    <h5 class="card-title text-center">TECHNICAL DEV SUPPORT</h5>
                    <p class="card-text text-center">
                        Development Support in - Java, Spring Boot Microservices, Angular.
                        Providing support in understanding your work and code. <br>
                        <b>₹1999/2hr session</b>
                    </p>
                    <a href="mailto:rohit.rana0207@gmail.com" class="btn btn-hire btn-block">Contact</a>
                </div>
            </div>
        </div>
    
    </div>
</div>